<!--
 * @Author: Narcissus
 * @Date: 2022-10-25 18:03:52
 * @LastEditTime: 2022-11-02 14:19:56
 * @LastEditors: Narcissus
 * @Description:
 * @FilePath: \hi-tom\src\layout\index.vue
-->
<!--  -->
<template>
  <div>
    <div class="header-wrapper">
      <div class="head_container" style="">
        <div class="move_left_box">
          <h1 class="project_logo_box" @click="toPage">Hi-TOM 2.0</h1>
          <div class="nav_content_box">
            <head-nav></head-nav>
          </div>
        </div>
      </div>
    </div>
    <div>
      <head-decorate></head-decorate>
    </div>
    <div>
      <router-view></router-view>
    </div>
    <div>
      <bottom-module></bottom-module>
    </div>
  </div>
</template>

<script>
import headNav from './components/head-nav/index';
import headDecorate from './components/head-decorate/index.vue';
import bottomModule from './components/bottom-module/index.vue';
export default {
  data() {
    return {};
  },

  components: { headNav, bottomModule, headDecorate },

  computed: {},

  mounted() {},

  methods: {
    toPage() {
      this.$router.push('/');
    },
  },
};
</script>
<style scoped>
.header-wrapper {
  background-color: #3b4348;
  width: 100%;
  /* height: auto; */
}

.head_container {
  position: relative;
  width: 1400px;
  height: 75px;
  /* margin: auto; */
  box-sizing: border-box;
  /* padding: 8px 0 10px 200px; */
  padding-left: 100px;
}

.head_container > img {
  margin-top: 2px;
}

.nav_content_box {
  /* position: absolute;
  left: 400px;
  bottom: 0; */
  margin-left: 100px;
  display: inline-block;
  vertical-align: text-top;
}

.project_logo_box {
  display: inline-block;
  margin: 14px 0;
  vertical-align: text-top;
  color: #fff;
  cursor: pointer;
}
.move_left_box {
  /* position: absolute;
  bottom: 0;
  left: -250px;
  width: 100%; */
}
</style>



// WEBPACK FOOTER //
// src/layout/index.vue